// import './modules/iframeHeight.js'
// import './modules/thumbnavSlider.js'
import './modules/stickyHeader.js'
import './modules/cf7FloatingLabel.js'
import './modules/cf7Events.js'

document.addEventListener("DOMContentLoaded", function () {
  // Handler when the DOM is fully loaded
  console.log('js executed...');
  
});

